/* eslint-disable prettier/prettier */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-param-reassign */
import React, {
  useRef,
  useCallback,
  useState,
  useEffect,

} from 'react';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import { getYear } from 'date-fns';
import * as Yup from 'yup';

import { Button, Row, Col } from 'react-bootstrap';

import 'react-credit-cards-2/dist/es/styles-compiled.css';

import Card from 'react-credit-cards-2';

import { buscaCep } from '../../utils/buscaCep';

import getValidationErrors from '../../utils/getValidationErrors';

import { useToast } from '../../hooks/toast';
import { useAuth } from '../../hooks/auth';
import { useCategoria } from '../../hooks/categoria';

import SelectSync from '../SelectSync';
import Input from '../Input';

import {
  replaceCaracteres,
  TIPO_USUARIO,
  validarCNPJ,
} from '../../utils/funcoes';

import { Container } from './styles';
import api from '../../services/api';

import Loading from '../Loading';
import getResponseErrors from '../../utils/getResponseErrors';

import InputMask from '../InputMask';
import validarCpf from '../../utils/validarCpf';

const INITIAL_STATE = {
  cvc: '',
  cardExpirationMonth: '',
  cardExpirationYear: '',
  cardholderName: '',
  cardNumber: '',
  identificationType: 'CPF',
  parcela: '1',
};



type AssinaturaProps = {
  plaCodigo: number;
  tipo: string;
  handleFechar(load: boolean): void;
};


interface IFormProps extends FormHandles {
  cardholderName: string;
  cardholderEmail: string;
  identificationNumber: string;
  identificationType: string;
  cvc: string;
  cardExpirationMonth: string;
  cardExpirationYear: string;
  cardNumber: number
  endereco: string;
  numero: string;
  cep: string;
  telefone: string;

}

const ano = getYear(new Date());
const optionsAno = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15].map(
  value => {
    return {
      value: String(ano + value).substring(2, 4),
      label: String(ano + value),
    };
  },
);

function validarCpfCnpf(valor: string | undefined): boolean {
  if (!valor) return false
  if (valor.length === 11) return validarCpf(valor)
  if (valor.length === 14) return validarCNPJ(valor)
  return false
}

const AlterarCartaoAssinatura: React.FC<AssinaturaProps> = ({
  plaCodigo,
  tipo,
  handleFechar,
}) => {
  const { user } = useAuth();

  const [state, setState] = useState(INITIAL_STATE);

  const [loading, setLoading] = useState(false);

  const [loadingCep, setLoadingCep] = useState(false);
  const [ip, setIp] = useState<string>('');

  const formRefPagamento = useRef<IFormProps>(null);

  const { addToast } = useToast();



  useEffect(() => {
    async function pegaIp(): Promise<void> {
      try {
        const response = await fetch('https://api64.ipify.org');
        const data = await response.text();
        setIp(data);
      } catch (error) {
        setIp('10.1.1.1');
        console.log('não foi possível identificar o IP');
      }
    }
    pegaIp();
  }, []);




  // eslint-disable-next-line @typescript-eslint/no-empty-function
  const handleOnChangeVazio = useCallback(() => { }, []);

  const handleBuscaCepApi = useCallback(
    async (value: string) => {
      const cep = replaceCaracteres(value);
      if (cep.length !== 8) return;

      setLoadingCep(true);

      const retornoCep = await buscaCep(cep);

      // if (retornoCep.erro) {
      //   setError('cep', {
      //     type: 'custom',
      //     message: 'CEP inválido',
      //   });
      //   return;
      // }

      const { logradouro } = retornoCep;
      const dados = formRefPagamento.current?.getData();
      formRefPagamento.current?.setData({ ...dados, 'endereco': logradouro });
      // setFocus('numero');
      setLoadingCep(false);
    },
    [],
  );


  const validaDados = useCallback(async (dadosForm): Promise<boolean> => {
    try {
      formRefPagamento.current?.setErrors({});

      const schemaPadrao = Yup.object().shape({
        cardholderName: Yup
          .string()
          .min(10, 'Mínimo de 10 caracteres')
          .required('Nome é obrigatório'),
        cardholderEmail: Yup.string()
          .required('E-mail obrigatório')
          .email('Digite um e-mail válido'),
        identificationNumber: Yup
          .string()
          .min(11, 'Mínimo 11 caracteres')
          .required('Número do documento é obrigatório')
          .test('test-invalid-cpf', 'Documento inválido', (doc) =>
            validarCpfCnpf(doc),
          ),
        identificationType: Yup.string().required('Tipo é obrigatório'),
        cvc: Yup
          .string()
          .min(1, 'CVV Inválido')
          .max(9999, 'CVV Inválido')
          .typeError('Campo obrigatório, digite apenas números')
          .required(),
        cardExpirationMonth: Yup
          .string()
          .min(1, 'Mês deve ser entre 01 e 12')
          .max(12, 'Mês deve ser entre 01 e 12')
          .typeError('Campo obrigatório, digite apenas números')
          .required(),
        cardExpirationYear: Yup
          .string()
          .max(99)
          .typeError('Campo obrigatório, digite apenas números')
          .required()
          .test('select', 'Selecione um item', (value) => value !== '0'),
        cardNumber: Yup
          .number()
          .typeError('Campo obrigatório,minimo 16 dígitos')
          .required(),
        endereco: Yup
          .string()
          .min(5, 'Mínimo 5 caracteres')
          .required('Endereço é obrigatório'),
        numero: Yup.string().required('Campo obrigatório'),
        cep: Yup
          .string()
          .required('CEP é obrigatório')
          .test('test-invalid-cep', 'Mínimo 8 dígitos', (cep) => {
            if (!cep) return false
            const numsStr = replaceCaracteres(cep)
            return numsStr.length === 8
          }),
        telefone: Yup
          .string()
          .min(10, 'Mínimo 10 dígitos')
          .min(11, 'Mínimo 11 dígitos')
          .test('test-invalid-Tel', 'Mínimo 10 dígitos', (tel) => {
            if (!tel) return false
            const numsStr = replaceCaracteres(tel)
            return numsStr.length >= 10
          })
          .required('Telefone é obrigatório'),

      })

      await schemaPadrao.validate(dadosForm, {
        abortEarly: false,
      });
      return true;
    } catch (error) {
      if (error instanceof Yup.ValidationError) {
        const errors = getValidationErrors(error);
        formRefPagamento.current?.setErrors(errors);
      }
      return false;
    }
  }, []);



  const handleSubmit = useCallback(
    async () => {
      formRefPagamento.current?.setErrors({});

      if (formRefPagamento.current) {
        const {
          cardholderName,
          cardholderEmail,
          identificationNumber,
          identificationType,
          cvc,
          cardExpirationMonth,
          cardExpirationYear,
          cardNumber,
          endereco,
          numero,
          cep,
          telefone,
        } = formRefPagamento.current.getData();

        setLoading(true);

        const dadosForm = {
          cardholderName,
          cardholderEmail,
          identificationNumber,
          identificationType,
          cvc,
          cardExpirationMonth,
          cardExpirationYear,
          cardNumber,
          endereco,
          numero,
          cep,
          telefone,
        };

        const validado = await validaDados(dadosForm);

        if (!validado) {

          setLoading(false);
          return;
        }

        const dadosFormatados = {
          remoteIp: ip,
          tipo: Number(tipo),
          creditCard: {
            holderName: cardholderName,
            number: replaceCaracteres(cardNumber.toString()),
            expiryMonth: cardExpirationMonth.toString(),
            expiryYear: cardExpirationYear,
            ccv: cvc.toString(),
          },
          creditCardHolderInfo: {
            name: cardholderName,
            email: cardholderEmail,
            cpfCnpj: replaceCaracteres(identificationNumber),
            postalCode: replaceCaracteres(cep),
            addressNumber: numero,
            phone: replaceCaracteres(telefone),
          },

        };

        try {

          await api.put(
            `/caixa/atualizaCartaoAssinatura/${plaCodigo}`,
            dadosFormatados,
          );

          addToast({
            type: 'success',
            title: 'Salvo com sucesso',
          });
          handleFechar(true);
        } catch (error: any) {
          const mensagemErro = getResponseErrors(error);

          addToast({
            type: 'error',
            title: 'Erro ao salvar pagamento',
            description: mensagemErro,
          });
        }
        setLoading(false);
      }
    }, [
    ip,
    addToast,
    validaDados,
    handleFechar,
    setLoading,
    tipo,
    plaCodigo,
  ]);


  const handleOnChangeInput = useCallback(
    (year: string | undefined) => {
      const dados = formRefPagamento.current?.getData();

      if (dados) {
        const {
          cvc,
          cardExpirationMonth,
          cardExpirationYear,
          cardholderName,
          cardNumber,
          identificationType,
          parcela,
        } = dados;
        setState({
          cvc: cvc.toString(),
          cardExpirationMonth: cardExpirationMonth.toString(),
          cardExpirationYear: year || cardExpirationYear.toString(),
          cardholderName,
          cardNumber: cardNumber.toString(),
          identificationType,
          parcela,
        });
      }
    },
    [],
  );

  return (
    <>
      <Container>
        {loading && <Loading backgroundBlack={false} />}
        <Row className={`no-gutters `}>
          <Col md="12" lg="12" className="form-group pr-2">
            <Card
              cvc={state.cvc}
              expiry={state.cardExpirationMonth + state.cardExpirationYear}
              name={state.cardholderName}
              number={state.cardNumber}
            />
          </Col>
        </Row>
        <Form
          ref={formRefPagamento}
          // initialData={{ CprValorPag: '' }}
          onSubmit={handleSubmit}

        >
          <Row noGutters>
            <Col md="4" lg="4" className="form-group pr-2">
              <InputMask
                name="cardNumber"
                label="Número do Cartão"
                placeholder="1234 0000 0000 0000"
                mask="9999 9999 9999 9999"
                onFocus={(data: any) => {
                  formRefPagamento.current?.setFieldError('cardNumber', '');
                }}
                onChange={(data: any) => {

                  handleOnChangeInput(undefined);
                }}
              />
            </Col>
            <Col md="8" lg="8" className="form-group pr-2">
              <Input
                label="Nome"
                name="cardholderName"
                placeholder="Igual ao escrito no cartão"
                onFocus={(data: any) => {
                  formRefPagamento.current?.setFieldError('cardholderName', '');
                }}
                onChange={(data: any) => {
                  handleOnChangeInput(undefined);
                }}
              />
            </Col>
          </Row>
          <Row noGutters>
            <Col md="2" lg="2" className="form-group pr-2">
              <Input
                name="cardExpirationMonth"
                label="Mês"
                placeholder="00"
                onFocus={(data: any) => {
                  formRefPagamento.current?.setFieldError('cardExpirationMonth', '');
                }}
                onChange={(data: any) => {

                  handleOnChangeInput(undefined);
                }}
              />
            </Col>

            <Col md="3" lg="3" className="form-group pr-2">
              <SelectSync
                name="cardExpirationYear"
                label="Ano"
                placeholder="Selecione"
                isClearable={false}
                handleSelectChange={handleOnChangeVazio}
                options={optionsAno || { label: '', value: '' }}
                onFocus={(data: any) => {
                  formRefPagamento.current?.setFieldError('cardExpirationYear', '');
                }}
                onChange={(data: any) => {
                  handleOnChangeInput(undefined);
                }}
              />
            </Col>

            <Col md="2" lg="2" className="form-group pr-2">
              <Input
                name="cvc"
                label="CVC"
                placeholder="000"
                onFocus={(data: any) => {
                  formRefPagamento.current?.setFieldError('cvc', '');
                }}
                onChange={(data: any) => {
                  handleOnChangeInput(undefined);
                }}
              />
            </Col>

            <Col md="5" lg="5" className="form-group pr-2">
              <InputMask
                name="telefone"
                label="Telefone"
                mask="(99) 99999-9999"
                placeholder="(00) 00000-0000"
              />

            </Col>
          </Row>
          <Row noGutters>
            <Col md="3" lg="3" className="form-group pr-2">
              <SelectSync
                name="identificationType"
                label="Documento"
                placeholder="Selecione"
                isClearable={false}
                handleSelectChange={handleOnChangeVazio}
                onFocus={(data: any) => {
                  formRefPagamento.current?.setFieldError('identificationType', '');
                }}
                options={[
                  { label: 'CPF', value: 'CPF' },
                  { label: 'CNPJ', value: 'CNPJ' },
                ]}
              />

            </Col>

            <Col md="3" lg="3" className="form-group pr-2">
              <Input
                name="identificationNumber"
                label="Nº Documento"
                onFocus={(data: any) => {
                  formRefPagamento.current?.setFieldError('identificationNumber', '');
                }}
              />
            </Col>

            <Col md="6" lg="6" className="form-group pr-2">
              <Input
                name="cardholderEmail"
                label="E-mail"
                placeholder="E-mail"
              />
            </Col>


          </Row>

          <Row noGutters>
            <Col md="2" lg="2" className="form-group pr-2">
              <InputMask
                name="cep"
                label={loadingCep ? 'Buscando...' : 'CEP'}
                mask="99.999-999"
                placeholder="00.000-000"
                onBlur={(data: any) => {
                  handleBuscaCepApi(data.target.value);
                }}
              />

            </Col>

            <Col md="8" lg="8" className="form-group pr-2">
              <Input
                name="endereco"
                label="Endereço"
                placeholder="Endereço"
              />
            </Col>

            <Col md="2" lg="2" className="form-group pr-2">
              <Input
                name="numero"
                label="Nº do endereço"
                placeholder="Número"
              />
            </Col>
          </Row>


          <Row className="align-items-center border-top p-1">
            <Col md="12">
              <Container
                className={`light-grey text-left pt-3 ${user.UsuTipo > TIPO_USUARIO.ATENDENTE_CAIXA ? 'd-none' : ''
                  }`}
              >
                <>
                  <Button
                    type="submit"
                    variant="success"
                    style={{ paddingTop: '0.1rem', paddingBottom: '0.1rem' }}
                    size="sm"
                  >
                    Confirmar Cartão
                  </Button>
                </>
              </Container>
            </Col>
          </Row>
        </Form>
        {/* <Row className="align-items-center p-1">
          <Col md="12">
            <Container
              className={`light-grey text-left pt-3 ${ehCartaoSaude &&
                contaPRSelecionada?.CprChave &&
                !contaPRSelecionada?.CprPago &&
                clinica.ConfigBoleto?.EmiteOnLine &&
                process.env.REACT_APP_URL_SITE &&
                contaPRSelecionada?.CprValor >= 5
                ? ''
                : 'd-none'
                }`}
            >
              <CopiarAreaTrabalho
                texto={`${process.env.REACT_APP_URL_SITE}/cartao/pagamentoAssinatura/${contaPRSelecionada?.CprChave}`}
              />
            </Container>
          </Col>
        </Row> */}
      </Container>
    </>
  );
};

export default AlterarCartaoAssinatura;
